export function initVideoPlayer() {
  document.querySelectorAll('[data-video-player]').forEach(container => {
    const video = container.querySelector('video');
    if (!video) return;

    const playBtn    = container.querySelector('[data-play]');
    const seekBar    = container.querySelector('[data-seek]');
    const volumeBar  = container.querySelector('[data-volume]');
    const muteBtn    = container.querySelector('[data-mute]');
    const fullscreen = container.querySelector('[data-fullscreen]');
    const speedSel   = container.querySelector('[data-speed]');
    const timeEl     = container.querySelector('[data-time]');
    const durationEl = container.querySelector('[data-duration]');

    function fmt(s) {
      const m = Math.floor(s / 60);
      const sec = Math.floor(s % 60).toString().padStart(2, '0');
      return `${m}:${sec}`;
    }

    if (playBtn) {
      playBtn.addEventListener('click', () => {
        video.paused ? video.play() : video.pause();
        const icon = playBtn.querySelector('i');
        if (icon) icon.className = video.paused ? 'fa-light fa-play' : 'fa-light fa-pause';
      });
    }

    video.addEventListener('timeupdate', () => {
      if (seekBar) seekBar.value = (video.currentTime / video.duration) * 100 || 0;
      if (timeEl) timeEl.textContent = fmt(video.currentTime);
    });

    video.addEventListener('loadedmetadata', () => {
      if (durationEl) durationEl.textContent = fmt(video.duration);
    });

    if (seekBar) {
      seekBar.addEventListener('input', () => {
        video.currentTime = (seekBar.value / 100) * video.duration;
      });
    }

    if (volumeBar) {
      volumeBar.addEventListener('input', () => {
        video.volume = volumeBar.value / 100;
        video.muted = video.volume === 0;
      });
    }

    if (muteBtn) {
      muteBtn.addEventListener('click', () => {
        video.muted = !video.muted;
        const icon = muteBtn.querySelector('i');
        if (icon) icon.className = video.muted ? 'fa-light fa-volume-xmark' : 'fa-light fa-volume';
      });
    }

    if (fullscreen) {
      fullscreen.addEventListener('click', () => {
        if (!document.fullscreenElement) {
          container.requestFullscreen?.();
        } else {
          document.exitFullscreen?.();
        }
      });
    }

    if (speedSel) {
      speedSel.addEventListener('change', () => {
        video.playbackRate = parseFloat(speedSel.value);
      });
    }
  });
}
